export default "__VITE_ASSET__1d8216c1__"